module.exports = __webpack_public_path__ + "static/media/tree-step-3_3.644fd5cc.svg";